const colors = [
  '#F36C60',
  '#F06292',
  '#BA68C8',
  '#9575CD',
  '#7986CB',
  '#91A7FF',
  '#4FC3F7',
  //'#4DD0E1',
  //'#4DB6AC',
  //'#42BD41',
  '#AED581',
  '#DCE775',
  '#FFF176',
  '#FFB74D',
  '#FF8A65',
  '#FF8A65',
  '#90A4AE',
]

function hashCode(string) {
  let hash = 5381, i = (string) ? string.length : 0
  while (i)
    hash = (hash * 33) ^ string.charCodeAt(--i)
  return hash >>> 0
}

function textToClipboard(text) {
  let textArea = document.createElement("textarea")
  textArea.value = text
  document.body.appendChild(textArea)
  textArea.focus()
  textArea.select()

  try {
    let successful = document.execCommand('copy')
    console.log('Fallback: Copying text command was ' + successful ? 'successful' : 'unsuccessful')
  } catch (err) {
    console.error('Fallback: Oops, unable to copy', err)
  }
  document.body.removeChild(textArea)
}

const baseUtils = {
  hashCode,
  textToClipboard,
  /**
   * Extract letters from name for avatar
   */
  getAvatarLetters: (username) => {
    if (!username || username === '')
      return ''
    username = username.trim()
    // TODO: username can contains not only latin chars!
    let words = username.match(/[a-zA-Z]+|[0-9]+(?:\.[0-9]+|)/g)
    if (words && words.length >= 2) {
      return words[0].substring(0, 1) + words[1].substring(0, 1)
    }
    return username.substring(0, 2)
  },
  getAvatarColor: (username) => {
    return colors[hashCode(username) % colors.length]    
  },

  equal: (a, b) => {
    return Object.entries(a).toString() === Object.entries(b).toString()
  }
}

export default baseUtils